import { IPropChildren } from '@ucheba/utils/helpers/components/prop.types'

export interface IAsideProps extends IPropChildren, IModAsideIndentSide {}

export enum EModAsideIndentSide {
  left = 'indentSide=left',
  right = 'indentSide=right',
  null = 'indentSide=null',
}

export interface IModAsideIndentSide {
  indentSide?: keyof typeof EModAsideIndentSide
}
